/**
 * Generates initials from a full name.
 * Takes the first character of the first two names and returns them in uppercase.
 *
 * @param name - Full name to extract initials from
 * @returns Initials string (max 2 characters)
 *
 * @example
 * getInitials('Ranni Montagna') // 'RM'
 * getInitials('John Doe Smith') // 'JD'
 */
export function getInitials(name: string): string {
  if (!name.trim()) return ''

  return name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}
